import { useState } from "react";
import { useSnackbar } from 'notistack';
// next
import { useRouter } from 'next/router';
// @mui
import {
  Box,
} from '@mui/material';
// componenets
import {
  Check3WayAvailableTime,
} from './';
// utils
import axios from '../../utils/axios';

export default function Reselect3WayTime({ offer, reloadOffer }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = useState(false);
  const router = useRouter();
  const { oid } = router.query;

  const reselectTimes = async (times) => {
    try {
      setIsSubmit(true);
      await axios.post(`api/crews/offers/${oid}/reselect-times/`, {
        crew_3way_time_range: times,
      });
      enqueueSnackbar('저장 되었습니다');
      reloadOffer();
      setIsSubmit(false);
    } catch (err) {
      console.error(err);
      setIsSubmit(false);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Check3WayAvailableTime
        send={reselectTimes}
        isSubmitting={isSubmit}
        reselect={true}
        timeComment={offer?.time_comment}
        previousTimes={offer?.crew_3way}
        meetingCount={offer?.meeting_3way_count}
      />
    </Box>
  )
};
